import i18n from "../../../locales/i18n";

export class ParticipantData {
  constructor({
    playerId,
    playerNumber,
    country,
    groupName,
    playerName,
    gender,
    position,
    groupEvent,
    indivEvent,
    note,
    attendance,
  }) {
    this.playerId = playerId;
    this.playerNumber = playerNumber || "-";
    this.country = country || "";
    this.groupName = groupName || "";
    this.playerName = playerName || "";
    this.gender = gender || "";
    this.position = position || "";
    this.groupEvent = groupEvent || "";
    this.indivEvent = indivEvent || "";
    this.note = note || "";
    this.attendance = attendance || 0;
  }

  static fromJson(json) {
    return new ParticipantData({
      playerId: json.player_id ?? json.playerId ?? 0,
      playerNumber: json.player_number ?? json.playerNumber ?? "",
      country: json.country ?? "",
      groupName: json.group_name ?? json.groupName ?? "",
      playerName: json.player_name ?? json.playerName ?? "",
      gender: json.gender ?? "",
      position: json.position ?? json.position ?? "",
      groupEvent: json.group_event ?? json.groupEvent ?? "",
      indivEvent: json.indiv_event ?? json.indivEvent ?? "",
      note: json.note ?? "-",
      attendance: json.attendance ?? 0,
    });
  }

  _getEventStatus(eventsString) {
    try {
      const events = JSON.parse(eventsString);
      return {
        distance30: events.includes("30m") ? "O" : "-",
        distance70: events.includes("70m") ? "O" : "-",
        distance90: events.includes("90m") ? "O" : "-",
        distance145: events.includes("145m") ? "O" : "-",
      };
    } catch {
      return {
        distance30: "-",
        distance70: "-",
        distance90: "-",
        distance145: "-",
      };
    }
  }

  get genderLabel() {
    const genderCode = this.gender === "W" ? "F" : this.gender;

    if (genderCode === "M") {
      return i18n.t('common.m');
    } else if (genderCode === "F") {
      return i18n.t('common.f');
    }
    return genderCode;
  }

  get positionLabel() {
    let positions = [];
    try {
      positions = JSON.parse(this.position);
    } catch {
      positions = [];
    }
    const positionMap = {
      Executive: i18n.t('positions.executive'), // 임원
      Coach: i18n.t('positions.coach'), // 코치
      Player: i18n.t('positions.player'), // 선수
      Representative: i18n.t('positions.representative'), // 대표
    };
    const labels = positions.map((pos) => positionMap[pos] || pos);
    return labels.join(", ");
  }

  get groupEvents() {
    return this._getEventStatus(this.groupEvent);
  }

  get individualEvents() {
    return this._getEventStatus(this.indivEvent);
  }

  get attendanceLabel() {
    return this.attendance === 1 ? "O" : "X";
  }
}
